import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/scss/index.scss';
import reportWebVitals from './reportWebVitals';
import CssBaseline from '@mui/material/CssBaseline';
import { persistor, store } from '../src/redux-toolkit/store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { Amplify } from 'aws-amplify';
import { Auth } from '@aws-amplify/auth';
import awsConfig from './aws-exports';
import App from './App';
import { createTheme, ThemeOptions } from '@mui/material';
import { ThemeProvider } from '@mui/material';
import { MuiTheme } from './MuiTheme';
import './assets/scss/App.scss';

const theme = createTheme(MuiTheme);

theme.typography.h4 = {
	...theme.typography.h4,
	fontFamily: 'Poppins'
};


const isLocalhost = Boolean(
	window.location.hostname === 'localhost' ||
	// [::1] is the IPv6 localhost address.
	window.location.hostname === '[::1]' ||
	// 127.0.0.1/8 is considered localhost for IPv4.
	window.location.hostname.match(
		/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
	) ||
	window.location.hostname.match(
		/^192(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
	)
);

const [
	localRedirectSignIn,
	productionRedirectSignIn,
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
] = process.env.REACT_APP_REDIRECT_SIGN_IN!.split(',');


const [
	localRedirectSignOut,
	productionRedirectSignOut,
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
] = process.env.REACT_APP_REDIRECT_SIGN_OUT!.split(',');

const updatedAwsConfig = {
	...awsConfig,
	oauth: {
		...awsConfig.oauth,
		redirectSignIn: isLocalhost ? localRedirectSignIn : productionRedirectSignIn,
		redirectSignOut: isLocalhost ? localRedirectSignOut : productionRedirectSignOut,
	}
};
Amplify.configure(updatedAwsConfig);
Auth.configure(updatedAwsConfig);

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<React.StrictMode>
		<CssBaseline>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<ThemeProvider theme={theme}>
						<App />
					</ThemeProvider>
				</PersistGate>
			</Provider>
		</CssBaseline>
	</React.StrictMode>
);
reportWebVitals();
